import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WebchatEmailTemplateTabMenuItemPreview from './WebchatEmailTemplateTabMenuItemPreview';
import { emailTemplateSelectedInTabMenu } from 'store/actions/WebchatEmailTemplateAction';

export default function WebchatEmailTemplateTabMenu() {

  const { unmodifiedEmailTemplates, editor } = useSelector((state) => state.WebchatEmailTemplateReducer);
  const dispatch = useDispatch();

  const [activeTemplateId, setActiveTemplateId] = useState(null);

  const templateCardHelpText = (title) => {
    switch (title) {
      case 'Welcome':
        return 'Contacts receive this message as soon as they are eligible for a web-enabled journey. Use this email to get your customers excited to use this channel in conjunction to their purchased product. If there are pre-purchase preparation steps for your product, you can hint at them here as well.';
      case 'New Message':
        return 'Whenever a contact receives a new message while they are not using ChatStream, the customer is sent this email with a link to go to ChatStream directly.';
      case 'New Magic Link':
        return 'This message is sent when the Contact requests a new Magic Link. It includes a link which will log them in automatically when clicked.';
      default:
        return '';
    }
  }

  const handleTemplateClick = (templateId) => {
    dispatch(emailTemplateSelectedInTabMenu(templateId));
  }

  useEffect(() => {
    if (editor && editor.id) {
      setActiveTemplateId(editor.id.toString());
    }
  }, [editor]);

  return (
    <div>
      {unmodifiedEmailTemplates && Object.entries(unmodifiedEmailTemplates).map(([templateId, templateData]) => (
        <div
          key={templateId}
          className={`template-card ${activeTemplateId === templateId ? 'selected' : ''}`}
          onClick={() => handleTemplateClick(templateId)}>
          <div className="template-content">
            <p className="template-title">{templateData?.name}</p>
            <p className="template-body">{templateCardHelpText(templateData?.name)}</p>
          </div>
          <div className="template-preview-container">
            <WebchatEmailTemplateTabMenuItemPreview htmlContent={templateData && editor?.id === templateId ? editor?.body : templateData?.body} />
          </div>
        </div>
      ))}
    </div>
  );

}